import { ValidatorResult } from '../models/validation-result.model';
import { CrudService } from './crud.service';

export class ProductsDetailsService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('api/products-details');
  }

  public async getProductModelImages(itemNumber: string): Promise<ValidatorResult<string[]>> {
    return this.crudService.do('get', `${itemNumber}/images`);
  }
}
